export default {
	name: 'Name',
	gender: 'Gender',
	dob: 'Date of Birth',
	phone: 'Phone Number',
	commission: 'Commission',
	new_patient: 'New Patient',
	update_patient: 'Update Patient'
};
